// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import { createFolder, editFolder, getFolderList, deleteFolder } from './folderThunk';

export interface IFolderState {
  isRefreshFolderList: boolean;
}

export const initialState: IFolderState = {
  isRefreshFolderList: false,
};

const folderSlice = createSlice({
  name: 'folder',
  initialState,
  reducers: {
    setRefreshFolderList(state, action) {
      state.isRefreshFolderList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get folder list
    builder
      .addCase(getFolderList.pending, (state) => {})
      .addCase(getFolderList.fulfilled, (state) => {})
      .addCase(getFolderList.rejected, (state) => {});

    // POST: Create folder
    builder
      .addCase(createFolder.pending, (state) => {})
      .addCase(createFolder.fulfilled, (state) => {})
      .addCase(createFolder.rejected, (state) => {});

    // PUT: Edit folder
    builder
      .addCase(editFolder.pending, (state) => {})
      .addCase(editFolder.fulfilled, (state) => {})
      .addCase(editFolder.rejected, (state) => {});

    // DELETE: Delete folder
    builder
      .addCase(deleteFolder.pending, (state) => {})
      .addCase(deleteFolder.fulfilled, (state) => {})
      .addCase(deleteFolder.rejected, (state) => {});
  },
});

// Action
export const folderActions = folderSlice.actions;

// Selectors
export const selectIsRefreshFolderList = (state: RootState) => state.folder.isRefreshFolderList;

// Reducer
const folderReducer = folderSlice.reducer;
export default folderReducer;
